var _jsxFileName = "/media/data/Sandbox/soapbox-defake/app/soapbox/components/ui/emoji-selector/emoji-selector.tsx";
import classNames from 'clsx';
import React from 'react';
import { Emoji, HStack } from 'soapbox/components/ui';

/** Clickable emoji button that scales when hovered. */
const EmojiButton = _ref => {
  let {
    emoji,
    className,
    onClick,
    tabIndex
  } = _ref;
  return /*#__PURE__*/React.createElement("button", {
    className: classNames(className),
    onClick: onClick,
    tabIndex: tabIndex,
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 20,
      columnNumber: 5
    }
  }, /*#__PURE__*/React.createElement(Emoji, {
    className: "w-8 h-8 duration-100 hover:scale-125",
    emoji: emoji,
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 21,
      columnNumber: 7
    }
  }));
};

/** Panel with a row of emoji buttons. */
const EmojiSelector = _ref2 => {
  let {
    emojis,
    onReact,
    visible = false,
    focused = false
  } = _ref2;

  const handleReact = emoji => {
    return e => {
      onReact(emoji);
      e.preventDefault();
      e.stopPropagation();
    };
  };

  return /*#__PURE__*/React.createElement(HStack, {
    space: 2,
    className: classNames('bg-white dark:bg-gray-900 p-3 rounded-full shadow-md z-[999] w-max'),
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 49,
      columnNumber: 5
    }
  }, Array.from(emojis).map((emoji, i) => /*#__PURE__*/React.createElement(EmojiButton, {
    key: i,
    emoji: emoji,
    onClick: handleReact(emoji),
    tabIndex: visible || focused ? 0 : -1,
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 54,
      columnNumber: 9
    }
  })));
};

export default EmojiSelector;